import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BadgeModule } from '@commons/badge/badge.module';
import { LinkModule } from '@commons/link/link.module';
import { TabBarComponent } from '@commons/tab-bar/tab-bar.component';
import { TrackerModule } from '@commons/tracker/tracker.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

@NgModule({
  imports: [CommonModule, RouterModule, BadgeModule, PerfectScrollbarModule, LinkModule, TrackerModule],
  declarations: [TabBarComponent],
  exports: [TabBarComponent],
})
export class TabBarModule {}
